import styled from 'styled-components'

const BtnBackStyled = styled.div`
  cursor: pointer;
  width: fit-content;
  .btn-back {
    column-gap: 8px;
    font-size: 20px;
    color: white;
    padding: 10px 0;
    display: flex;
    align-items: center;
    .btn-name {
      font-weight: 600;
      padding-top: 5px;
    }
  }
`

export default BtnBackStyled
